// @flow

import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import React from 'react'
import { formatNumber } from '../utils'
import { A } from '@/components/atoms/A'

type Props = {
  value: number
}

export class ResultCount extends React.Component<Props> {
  render() {
    return (
      <div
        className="result-count"
        css={css`
          padding: 14px 0 14px 24px;
          color: #666;
          font-size: 14px;
          line-height: 1;
          margin-top: auto;
          margin-bottom: auto;
        `}
      >
        <span>
          検索結果{' '}
          <span
            className="count"
            css={css`
              margin: 0 6px 0 2px;
              font-size: 24px;
              color: ${colors.black10};
            `}
          >
            {formatNumber(this.props.value)}
          </span>{' '}
          社
        </span>
        <span
          className="annotation"
          css={css`
            font-size: 12px;
            color: ${colors.textLight};
            margin-left: 12px;
          `}
        >
          表示は30,000社まで
        </span>
        <A
          href="https://help.initial.inc/ja/articles/9818272"
          target="_blank"
          rel="noopener"
          css={css`
            text-decoration: none;
            margin-left: 24px;
          `}
        >
          今後の機能開発について
        </A>
      </div>
    )
  }
}
